import { useSyncExternalStore } from 'react';

export type ThemePref = 'auto' | 'dark' | 'light';
interface Prefs {
  theme: ThemePref;
  hideZero: boolean;
}

const KEY = 'onyx.prefs';
const defaults: Prefs = { theme: 'auto', hideZero: true };

function load(): Prefs {
  try {
    return { ...defaults, ...(JSON.parse(localStorage.getItem(KEY) ?? '{}') as Partial<Prefs>) };
  } catch {
    return defaults;
  }
}

let prefs = load();
const listeners = new Set<() => void>();

export function setPref<K extends keyof Prefs>(key: K, value: Prefs[K]) {
  prefs = { ...prefs, [key]: value };
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs));
  } catch {
    // Private mode: preferences stay in memory for this session.
  }
  listeners.forEach((l) => l());
}

export function usePrefs(): Prefs {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => prefs,
  );
}
